import React from 'react';
import { ViewPortionState } from './viewPortionState/viewPortionState';
import { Modal } from 'antd';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './index.module.scss';
import { PortionFullInfo } from '../ViewPortionModal/components/PortionFullInfo';

interface IProps {
	onCloseModal: () => void;
}

export const ViewPortionModal: React.FC<IProps> = ({ onCloseModal }) => {
	return (
		<ViewPortionState>
			<Modal
				width="60%"
				bodyStyle={{ padding: '40px' }}
				className={style.container}
				onCancel={onCloseModal}
				footer={null}
				visible={true}
				centered={false}
				destroyOnClose={true}
				closeIcon={
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#crossMark`} />
					</svg>
				}
				data-test="ViewPortionModal">
				<PortionFullInfo />
			</Modal>
		</ViewPortionState>
	);
};
